import { tw } from '@/lib/utils'

import type { SubscribeThemeTokens } from './theme'
import type { SubscribeFormContent } from './types'

const CheckMark = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden className="h-7 w-7">
    <path d="M5 12.5l4 4L19 7" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

interface SuccessPanelProps {
  content: SubscribeFormContent
  tokens: SubscribeThemeTokens
  onReset: () => void
}

export const SuccessPanel = ({ content, tokens, onReset }: SuccessPanelProps) => (
  <div className="flex animate-[fadeIn_0.4s_ease-out] flex-col items-center justify-center py-4 text-center">
    <span
      className={tw(
        'flex h-16 w-16 items-center justify-center rounded-full',
        tokens.successIconWrap,
        tokens.successIcon
      )}
    >
      <CheckMark />
    </span>
    <div
      className={tw('mt-5 text-[1.4rem] leading-tight tracking-[-0.01em]', tokens.successHeading)}
      style={{ fontFamily: 'var(--font-fraunces), Georgia, serif', fontWeight: 500 }}
    >
      {content.successHeading}
    </div>
    <p className={tw('mt-3 max-w-[300px] text-[0.9rem] leading-[1.5]', tokens.successMessage)}>
      {content.successMessage}
    </p>
    <button
      type="button"
      onClick={onReset}
      data-tracking="ignore"
      className={tw(
        'mt-5 cursor-pointer text-[0.85rem] font-medium tracking-[-0.01em] transition-colors',
        tokens.successReset
      )}
    >
      {content.subscribeAnotherText}
    </button>
  </div>
)
